<template>
    <div class="container">
        <OdsMenu @menuSelect="menuSelect"/>
        <div>
            <div class="introduction" >
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">BioOmics组学数据发布管理平台</h1>
                    <div data-aos="fade-up"></div>
                    <div data-aos="fade-up">
                        组学研究是后基因组时代生命科学发展的重要特征，开放共享的组学大数据已成为生命科学领域的重要研究资源，组学数据发布管理平台扮演数据生产者与数据用户之间的重要纽带。
                    </div>
                    <div data-aos="fade-up">
                      BioOmic 组学数据发布管理平台，是面向组学数据标准化提交、审核、发布和共享的信息管理系统。研究人员可通过平台提交基因组、转录组、蛋白质组、代谢组等相关数据，并完善数据来源、测序技术、生物学重复次数等元数据信息；经过元数据审核、数据发布、数据共享、知识挖掘等环节，完成组学研究数据的标准化提交、规范化审核与开放共享，提升组学数据与信息的可获取性、可重复性与可靠性，助力推动跨团队、跨学科交叉研究，为科研人员挖掘潜在生物学知识、探索前沿研究方向提供数据支撑。

                    </div>
                </div>
                <div data-aos="zoom-in">
                    <img :src="require('@/assets/img/database/bioOmics/introductionTitle.png')" alt="" >
                </div>
            </div>
            <div class="design">
                <div class="designTitle" data-aos="fade-up">设计理念</div>
                <div class="content" data-aos="zoom-in">
                    <div v-for="item in content">
                        <div class="contentTitle">{{item.title}}</div>
                        <div class="contentText">{{item.text}}</div>
                    </div>
                </div>
            </div>
            <div class="function">
                <div class="functionTitle" data-aos="fade-up">功能特点</div>
                <div class="functionList" v-for="item in functionList" data-aos="fade-up">
                    <div>{{item.title}}</div>
                    <div>{{item.text}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OdsMenu from "../../components/OdsMenu";
export default {
	components: {OdsMenu},
	data() {
		return {
            content:[
                {
                    title:'存得好',
                    text:'组学数据一站式存储管理，保障组学数据存储安全可靠'
                },
                {
                    title:'找得到',
                    text:'在科研应用时，可根据组学类型、平台型号等信息进行复杂组合，方便快捷的检索定位到患者、样本及组学数据信息。'
                },
                {
                    title:'开放共享',
                    text:'组学数据信息面向上级主管部门进行数据上传，同时可与相关科研机构合作机构共享应用'
                },
                {
                    title:'懂应用',
                    text:'能够根据组学数据不同实际应用场景，打造组学数据全流程闭环管理，样本关联溯源等，面向后续多组学数据分析'
                },{
                    title:'可追溯',
                    text:'以组学数据为中心，直观查阅组学数据全周期的数据信息。包括项目信息，患者信息、样本信息及组学信息等。'
                },

            ],
            functionList:[
                {
                    title:'汇总展示：',
                    text:'支持多组学数据融合及汇总展示，针对不同的实验平台及实验类型进行集中汇总及展示，便于后续相关的研究；'
                },
                {
                    title:'患者信息：',
                    text:'支持多组学数据患者信息管理，包括患者编号、姓名、性别、所属专病等信息；'
                },
                {
                    title:'实验信息：',
                    text:'支持多组学数据实验信息管理，包括实验命名、实验描述文本信息、样本测序文库的构建及测序方法的相关信息等；'
                },
                {
                    title:'组学数据上传：',
                    text:'支持多种平台数据上传；支持多种上传方式；文件上传后项目归档便捷；'
                },
                {
                    title:'组学数据检索：',
                    text:'检索结果以视图展示，一目了然；'
                },
                {
                    title:'组学数据分享：',
                    text:'所见即所得，检索、分享操作逻辑简单；'
                },
                {
                    title:'组学数据统计：',
                    text:'包括病种分布(如病种样本数、样本类型分布)与生信数据分布（如组学分布、组学统计）；'
                },
                {
                    title:'组学数据归档：',
                    text:'快速将组学数据（集）归入相应的批次及组学类型、所属实验室与样本编号等；'
                },
                {
                    title:'组学数据关联：',
                    text:'样本库系统可无缝对接回溯相应的组学数据，针对不同的实验平台及类型可进行上传和权限划分，支持多组学数据回溯及展示。'
                }
            ]
        }
	},
    methods:{
	    menuSelect(src){
	        this.$emit('menuSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1032px;
        margin: 0 5% 0;
        padding-top: 125px;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            width: 509px;
            padding-top: 84px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 2px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 15px;
                letter-spacing: 1px;
                line-height: 25px;
                text-indent: 2em;
            }
        }
    }
    .design{
        margin: 125px 6% 0;
        .designTitle{
            width: 113px;
            height: 25px;
            background-color: #006efd;
            font-family: SourceHanSansCN-Medium;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ffffff;
            line-height: 25px;
            text-align: center;
        }
        .content{
            width: 970px;
            height: 486px;
            padding-top: 293px;
            box-sizing: border-box;
            background: url("../../assets/img/database/bioOmics/contentBg.png") no-repeat;
            display: flex;
            justify-content: space-between;
            margin-left: 20px;
            margin-top: 66px;
            &>div{
                width: 173px;
                padding: 0 10px;
                box-sizing: border-box;
                .contentTitle{
                    font-size: 20px;
                    text-align: center;
                    color: #005be4;
                }
                .contentText{
                    margin-top: 6px;
                    font-size: 15px;
                    text-align: center;
                    letter-spacing: 1px;
                    line-height: 24px;
                }
            }
        }
    }
    .function{
        margin: 125px 6% 110px;
        .functionTitle{
            width: 113px;
            height: 25px;
            background-color: #006efd;
            font-family: SourceHanSansCN-Medium;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ffffff;
            line-height: 25px;
            text-align: center;
            margin-bottom: 28px;
        }
        .functionList{
            display: flex;
            margin-bottom: 10px;
            margin-left: 12px;
            div{
                font-size: 15px;
                color: #000;
            }
            &>div:nth-child(1){
                width: 114px;
                text-align:justify;
                text-align-last: justify;
                font-weight: bold;
            }
            &>div:nth-child(2){
                letter-spacing: 1px;
            }
        }
    }
</style>
